import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CentroDesarrolloGlobal from '../views/CentroDesarrolloGlobal.vue'
import InternationalPrograms from '../views/InternationalPrograms.vue'
import DoubleDegreePrograms from '../views/DoubleDegreePrograms.vue'
import TopManagementPrograms from '../views/TopManagementPrograms.vue'
import SeniorManagementPrograms from '../views/SeniorManagementPrograms.vue'
import ExecutiveCertificationPrograms from '../views/ExecutiveCertificationPrograms.vue'
import GlobalBusiness from '../views/GlobalBusiness.vue'
import Forums from '../views/Forums.vue'
import Activities from '../views/Activities.vue'
import News from '../views/News.vue'
import Agreements from '../views/Agreements.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/centro-desarrollo-global',
    name: 'Centro de desarrollo global',
    component: CentroDesarrolloGlobal
  },
  {
    path: '/programas-internacionales',
    name: 'Programas internacionales',
    component: InternationalPrograms
  },
  {
    path: '/programas-doble-certificacion-internacional',
    name: 'Programas de doble certificación internacional',
    component: DoubleDegreePrograms
  },
  {
    path: '/programas-formacion-ejecutiva',
    name: 'Programas de alta dirección',
    component: TopManagementPrograms
  },
  {
    path: '/programas-certificacion-red',
    name: 'Programas de alta gerencia',
    component: SeniorManagementPrograms
  },
  {
    path: '/actividades',
    name: 'Actividades',
    component: Forums
  },
  {
    path: '/noticias',
    name: 'Noticias',
    component: News
  },
  {
    path: '/convenios',
    name: 'Convenios',
    component: Agreements
  },
  {
    path: '/negocios-globales',
    name: 'Negocios globales',
    component: GlobalBusiness
  },
  {
    path: '/foros',
    name: 'Foros',
    component: Forums
  },
  {
    path: '/programas-certificacion-internacional',
    component: ExecutiveCertificationPrograms
  }
]

const router = new VueRouter({
  routes
})

export default router
